var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWalletCosmostation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.2 11.315h32.064a4.547 4.547 0 0 1 3.942 2.275l16.043 27.766-7.884 4.55-14.721-25.49H42.832l-13.4 23.215 14.71 25.49-7.884 4.552-16.032-27.766a4.535 4.535 0 0 1 0-4.551L36.258 13.59a4.56 4.56 0 0 1 3.942-2.275Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.76 30.955 7.884-4.55L79.676 54.17a4.537 4.537 0 0 1 0 4.55L63.644 86.488a4.56 4.56 0 0 1-3.941 2.275H27.639a4.55 4.55 0 0 1-3.942-2.275L7.665 58.72l7.884-4.551L30.27 79.66h26.812l13.4-23.215-14.721-25.49Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h100v100H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWalletCosmostation);
export default __webpack_public_path__ + "static/media/logo-wallet-cosmostation.3942da2033127e1659628aa8b59c60a4.svg";
export { ForwardRef as ReactComponent };